import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { inject, observer } from "mobx-react";
import AppLayout from "./layouts/AppLayout";
import Dashboard from "./pages/Dashboard";
import SearchDisplayHOC from "../micro/generic/SearchDisplayHOC";
import DischargeTemplatesCRUD from "../micro/v2/DischargeTemplatesCRUD";
import DoctorScheduleMaster from "./pages/masters/DoctorScheduleMaster";
import InsurancePanelMaster from "./pages/masters/InsurancePanelMaster";
import InsuranceCompanyMaster from "./pages/masters/InsuranceCompanyMaster";
import SurgeryGroupMaster from "./pages/masters/SurgeryGroupMaster";
import SurgeryPaymentMaster from "./pages/masters/SurgeryPaymentMaster";
import AnesthesiaPaymentMaster from "./pages/masters/AnesthesiaPaymentMaster";
import DischargeTemplates from "./pages/masters/DischargeTemplates";
import TPAMaster from "./pages/masters/TPAMaster";
import SurgeryBooking from "./pages/workflow/SurgeryBooking";
import SurgeryBookingDetails from "./pages/workflow/SurgeryBookingDetails";
import SurgeryWorkflow from "./pages/workflow/SurgeryWorkflow";
import SxCalendarBranchwise from "./pages/workflow/SxCalendarBranchwise";
import SurgerySearch from "./pages/workflow/SurgerySearch";
import DoctorwiseCalendar from "./pages/workflow/DoctorwiseCalendar";
import CashTill from "./pages/workflow/CashTill";
import BookingRegister from "./pages/reports/BookingRegister";
import PendingSurgeryRegister from "./pages/reports/PendingSurgeryRegister";
import PostponedRegister from "./pages/reports/PostponedRegister";
import CancelledSurgeries from "./pages/reports/CancelledSurgeries";
import AnesthetistReport from "./pages/reports/AnesthetistReport";
import BookingGivenReport from "./pages/reports/BookingGiven";
import IPDRegister from "./pages/reports/IPDRegister";
import IPDBillRegister from "./pages/reports/IPDBillRegister";
import IPDAppointment from "./pages/reports/IPDAppointment";
import IPDAgeGender from "./pages/reports/IPDAgeGender";
import MRBillRegister from "./pages/reports/MRBillRegister";
import DischargeRegister from "./pages/reports/DischargeRegister";
import TPAPaymentPanel from "./pages/reports/TPAPaymentPanel";
import MasterReport from "./pages/reports/MasterReport";
import ImplantInvoiceReport from "./pages/reports/ImplantInvoiceReport";
import { AuditLogPage } from "./pages/administration";

class V3App extends React.Component {
  componentDidMount() {
    console.log("V3App mounted, current location:", this.props.location.pathname);
  }

  render() {
    console.log("V3App render, current location:", this.props.location.pathname);
    return (
      <AppLayout location={this.props.location}>
        <Switch>
          {/* Dashboard */}
          <Route path="/v3" exact component={Dashboard} />
          <Route path="/v3/dashboard" exact component={Dashboard} />

          {/* Masters Routes */}
          <Route path="/v3/masters/counselling-prompts" exact>
            <SearchDisplayHOC
              displayTitle="Counselling Prompts"
              entityType="sxCounsellingPrompt"
              icon="chat"
              indexContentName="Prompt"
              renderType="LIST"
            />
          </Route>

          <Route path="/v3/masters/consent-lists" exact>
            <SearchDisplayHOC
              displayTitle="Consent Lists"
              entityType="sxConsentList"
              icon="form"
              indexContentName="Consent"
              renderType="LIST"
            />
          </Route>

          <Route path="/v3/masters/operating-theatres" exact>
            <SearchDisplayHOC
              displayTitle="Operating Theatres"
              entityType="sxOTMaster"
              icon="cut"
              indexContentName="OT"
              renderType="LIST"
            />
          </Route>

          <Route path="/v3/masters/discharge-templates" exact>
            <DischargeTemplatesCRUD />
          </Route>

          <Route path="/v3/masters/payment-panels" exact>
            <SearchDisplayHOC
              displayTitle="Payment Panels"
              entityType="sxPaymentPanelMaster"
              icon="credit-card"
              indexContentName="Checklist"
              renderType="LIST"
            />
          </Route>

          <Route path="/v3/masters/tpas" exact>
            <SearchDisplayHOC
              displayTitle="TPAs"
              entityType="sxTPAMaster"
              icon="inner-join"
              indexContentName="Checklist"
              renderType="LIST"
            />
          </Route>

          <Route path="/v3/masters/anaesthesia-prices" exact>
            <SearchDisplayHOC
              displayTitle="Anaesthesia Prices"
              entityType="sxAnaesthesiaPriceMaster"
              icon="syringe"
              renderType="TABLE"
              columns={[
                "Type",
                "Site",
                "Hospital Charge",
                "Anaesthetist Fee",
                "Total",
              ]}
            />
          </Route>

          <Route path="/v3/masters/bed-ward-prices" exact>
            <SearchDisplayHOC
              displayTitle="Bed & Ward Prices"
              entityType="sxBedMaster"
              icon="home"
              renderType="TABLE"
              columns={["Site", "Bed", "Ward", "Rate"]}
            />
          </Route>

          <Route path="/v3/masters/post-surgery-contacts" exact>
            <SearchDisplayHOC
              displayTitle="Post Surgery Contacts"
              entityType="SxPostSurgeryContactList"
              icon="person"
              renderType="TABLE"
              columns={["Name", "Phone", "Availability"]}
            />
          </Route>

          <Route path="/v3/masters/adverse-events" exact>
            <SearchDisplayHOC
              displayTitle="Adverse Events"
              entityType="SxAdverseEventMaster"
              icon="issue"
              renderType="TABLE"
              columns={["Adverse Event", "Description"]}
            />
          </Route>

          <Route path="/v3/masters/surgery-prices" exact>
            <SearchDisplayHOC
              displayTitle="Surgery Prices"
              entityType="sxPriceMaster"
              icon="bank-account"
            />
          </Route>

          <Route path="/v3/masters/surgeon-schedules" exact>
            <SearchDisplayHOC
              displayTitle="Surgeon Schedules"
              entityType="sxSurgeonSchedule"
              icon="timeline-events"
              renderType="TABLE"
              columns={["Schedule"]}
            />
          </Route>

          <Route path="/v3/masters/anaesthetist-schedules" exact>
            <SearchDisplayHOC
              displayTitle="Anaesthetist Schedules"
              entityType="sxAnaesthetistSchedule"
              icon="timeline-events"
              renderType="TABLE"
              columns={[
                "Anaesthetist",
                "Site",
                "From",
                "To",
                "Mon",
                "Tues",
                "Wed",
                "Thurs",
                "Fri",
                "Sat",
                "Sun",
              ]}
            />
          </Route>

          {/* Masters Routes */}
          <Route path="/v3/masters/doctor-schedules" exact>
            <DoctorScheduleMaster />
          </Route>
          <Route path="/v3/masters/insurance-panel" exact>
            <InsurancePanelMaster />
          </Route>
          <Route path="/v3/masters/insurance-company" exact>
            <InsuranceCompanyMaster />
          </Route>
          <Route path="/v3/masters/tpa-master" exact>
            <TPAMaster />
          </Route>
          <Route path="/v3/masters/surgery-group" exact>
            <SurgeryGroupMaster />
          </Route>
          <Route path="/v3/masters/surgery-payment-master" exact>
            <SurgeryPaymentMaster />
          </Route>
          <Route path="/v3/masters/anesthesia-payment-master" exact>
            <AnesthesiaPaymentMaster />
          </Route>
          <Route path="/v3/masters/discharge-templates" exact>
            <DischargeTemplates />
          </Route>

          {/* Workflow Routes */}
          <Route path="/v3/workflow/surgery-booking" exact>
            <SurgeryBooking />
          </Route>
          <Route path="/v3/workflow/cash-till" exact>
            <CashTill />
          </Route>
          <Route path="/v3/workflow/sx-calendar-branchwise" exact>
            <SxCalendarBranchwise />
          </Route>
          <Route path="/v3/workflow/surgery-search" exact>
            <SurgerySearch />
          </Route>
          <Route path="/v3/workflow/doctorwise-calendar" exact>
            <DoctorwiseCalendar />
          </Route>
          <Route path="/v3/workflow/surgery-booking/:id" exact>
            <SurgeryBookingDetails />
          </Route>
          <Route path="/v3/workflow/surgery-workflow" exact>
            <SurgeryWorkflow />
          </Route>

          {/* Reports Routes */}
          <Route path="/v3/reports/surgery-report" exact>
            <SearchDisplayHOC
              displayTitle="Surgery Report"
              entityType="sxBookingReport"
              icon="cut"
              renderType="GRID"
            />
          </Route>

          <Route path="/v3/reports/payment-report" exact>
            <SearchDisplayHOC
              displayTitle="Payment Report"
              entityType="sxPaymentReport"
              icon="credit-card"
              renderType="GRID"
            />
          </Route>

          <Route path="/v3/reports/insurance-report" exact>
            <SearchDisplayHOC
              displayTitle="Insurance Report"
              entityType="sxInsuranceReport"
              icon="bank-account"
              renderType="GRID"
            />
          </Route>

          <Route path="/v3/reports/item-consumption-report" exact>
            <SearchDisplayHOC
              displayTitle="Item Consumption Report"
              entityType="sxItemConsumptionReport"
              icon="full-stacked-chart"
              renderType="GRID"
            />
          </Route>

          <Route path="/v3/reports/surgery-register-report" exact>
            <SearchDisplayHOC
              displayTitle="Surgery Register Report"
              entityType="sxBookingRegisterReport"
              icon="cut"
              renderType="GRID"
            />
          </Route>

          {/* New Reports Routes */}
          <Route path="/v3/reports/booking-register" exact>
            <BookingRegister />
          </Route>
          <Route path="/v3/reports/pending-surgery-register" exact>
            <PendingSurgeryRegister />
          </Route>
          <Route path="/v3/reports/postponed-register" exact>
            <PostponedRegister />
          </Route>
          <Route path="/v3/reports/cancelled-surgeries" exact>
            <CancelledSurgeries />
          </Route>
          <Route path="/v3/reports/anaesthetist-report" exact>
            <AnesthetistReport />
          </Route>
          <Route path="/v3/reports/booking-given" exact>
            <BookingGivenReport />
          </Route>
          <Route path="/v3/reports/ipd-register" exact>
            <IPDRegister />
          </Route>
          <Route path="/v3/reports/ipd-bill-register" exact>
            <IPDBillRegister />
          </Route>
          <Route path="/v3/reports/mr-bill-register" exact>
            <MRBillRegister />
          </Route>
          <Route path="/v3/reports/ipd-appointment" exact>
            <IPDAgeGender />
          </Route>
          <Route path="/v3/reports/ipd-age-gender" exact>
            <IPDAgeGender />
          </Route>
          <Route path="/v3/reports/discharge-register" exact>
            <DischargeRegister />
          </Route>
          <Route path="/v3/reports/tpa-payment-panel" exact>
            <TPAPaymentPanel />
          </Route>
          <Route path="/v3/reports/master-report" exact>
            <MasterReport />
          </Route>
          <Route path="/v3/reports/implant-invoice-report" exact>
            <ImplantInvoiceReport />
          </Route>

          {/* Administration Routes */}
          <Route path="/v3/administration/audit-logs" exact>
            <AuditLogPage />
          </Route>

          {/* Surgeries Routes */}
          <Route path="/v3/surgeries" exact>
            <SearchDisplayHOC
              displayTitle="Surgical Procedures"
              entityType="sxBooking"
              icon="cut"
              renderType="TABLE"
              columns={[
                "Surgery ID",
                "Patient ID",
                "Patient Name",
                "Patient Age",
                "Patient Gender",
                "Surgeries",
                "Eye",
                "Items needed in Surgery",
                "Anaesthesia",
                "Remarks",
                "Diet",
                "Site",
                "Surgeon",
                "Date",
                "Lifecycle",
                "Details",
              ]}
            />
          </Route>

          {/* Fallback route for debugging */}
          <Route path="*">
            <div
              style={{
                padding: "20px",
                color: "#f5f8fa",
                backgroundColor: "#1a1a1a",
                minHeight: "100vh",
              }}
            >
              <h1>Route not found: {this.props.location.pathname}</h1>
              <p>This route is not defined in V3App.js</p>
              <p>Available routes:</p>
              <ul>
                <li>/v3/masters/doctor-schedules</li>
                <li>/v3/masters/insurance-panel</li>
                <li>/v3/masters/surgery-group</li>
                <li>/v3/masters/surgery-payment-master</li>
                <li>/v3/masters/discharge-templates</li>
                <li>/v3/workflow/surgery-booking</li>
              </ul>
            </div>
          </Route>
        </Switch>
      </AppLayout>
    );
  }
}

export default inject("root", "authStore")(observer(V3App));
